//Reset data
export const RESET = "IA_CLASSIFICATION_RESET"

//Loading
export const SET_TOGGLE_LOADING = "IA_CLASSIFICATION_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "IA_CLASSIFICATION_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "IA_CLASSIFICATION_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "IA_CLASSIFICATION_SET_MESSAGE"
export const SET_IS_SUCCESS = "IA_CLASSIFICATION_SET_IS_SUCCESS"
export const SET_IS_ERROR = "IA_CLASSIFICATION_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "IA_CLASSIFICATION_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "IA_CLASSIFICATION_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "IA_CLASSIFICATION_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "IA_CLASSIFICATION_SET_ITEMS"
export const SET_CURRENT_ITEM = "IA_CLASSIFICATION_SET_CURRENT_ITEM"

export const SET_PAGINATION = "IA_CLASSIFICATION_SET_PAGINATION"
